import styles from '@styles/components/buy-in-bulk/general-slider/index.module.scss';
import {Swiper, SwiperSlide} from 'swiper/react';
import Link from "next/link";
import {Navigation, Pagination, Scrollbar, A11y, EffectFade} from 'swiper';
import React, {useRef, useState} from "react";
import {useInView} from "framer-motion";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

export const BuyInBulkGeneralSlider = (props: { ItemList: any[]; itemType: string; tag: string, title: string, type: string }) => {

    // Animation of image when scrolling and in view
    const ref = useRef(null);
    const isInView = useInView(ref, {once: false});

    // Configuration for swiper
    const swiperConfig = {
        modules: [Navigation, Pagination, Scrollbar, A11y, EffectFade],
        spaceBetween: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
        initialSlide: 0,
        loop: true,
        fade: "true",
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 70,
            },
            481: {
                slidesPerView: 2,
                spaceBetween: 0,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 70,
            },
            1025: {
                slidesPerView: 3.85,
                spaceBetween: 0,
            },
            1201: {
                slidesPerView: 3.85,
                spaceBetween: 0,
            }
        }
    }

    /**
     * Variables are used for the class for the images to animate it, the value are changed based on the state of the image
     */
    const animateImages = () => {
        setLeftImgClassList1("img_left img_left_rotate_1 img_left_animate ");
        setRightImgClassList1("img_right img_right_rotate_1 img_right_animate");
        setLeftImgClassList2("img_left img_left_rotate_1");
        setRightImgClassList2("img_right img_left_rotate_1");
        setTimeout(() => {
            setLeftImgClassList1("img_left");
            setRightImgClassList1("img_right");
            setLeftImgClassList2("img_left img_left_rotate_1");
            setRightImgClassList2("img_right img_right_rotate_1");
        }, 1000);
    };

    // Animation Image State Management and classes
    const [currentImages, setCurrentImages] = useState({leftImageUrl: '', rightImageUrl: ''});
    const [rightImgClassList1, setRightImgClassList1] = useState("img_right img_right_rotate_1");
    const [rightImgClassList2, setRightImgClassList2] = useState("img_right");
    const [leftImgClassList1, setLeftImgClassList1] = useState("img_left img_left_rotate_1");
    const [leftImgClassList2, setLeftImgClassList2] = useState("img_left");

    /***
     * This section contains code of the honey items in horizontal scroll.
     * Used swiper for horizontal infinite scroll.
     * It contains 3 title, and the css are inherited from root style and for inner image ,title and line
     * the style is defined in the separate file of this component.
     */
    // @ts-ignore
    return (
        <section className={`product-container ${styles.slider_list}`}>
            <div className={'titles'}>
                <h3 className={'title-bold'}>{props.title}</h3>
                <span className={'title-normal'} dangerouslySetInnerHTML={{__html: props.type}}></span>
            </div>
            <Swiper {...swiperConfig} slidesPerView={"auto"} ref={ref} onSlideChange={(swipe) => {
            }}>
                {

                    props.ItemList.map((item, index) => {
                        return (<SwiperSlide key={props.itemType + '-' + index} className={`${styles.honey_item}`}>
                            <Link href={'/products/detail/' + props.itemType + '-bulk/' + item.Shopify_Link}>
                                <img className={`${isInView ? 'slide-up-animation-active' : 'slide-up-animation'}`}
                                     loading={"lazy"}
                                     src={item.Image_Buy_In_Bulk.url} alt={item.Image_Buy_In_Bulk.alternativeText}/>
                                <div className={styles.bar_line}></div>
                                <div>
                                    <span suppressHydrationWarning={true}>{item.Title_Buy_In_Bulk}</span>
                                    <div className={styles.vertical_line}></div>
                                    <span>{item.Buy_In_Bulk_Pcs} PCS</span>
                                </div>
                            </Link>
                        </SwiperSlide>)
                    })
                }
                <div className={`swiper-button-prev ${styles.swiper_button_prev_next}`} tabIndex={0} role="button"
                     aria-label="Previous slide">
                    <img src="/assets/images/decorations/extra/left_arrow.png" alt="previous"/>
                </div>
                <div className={`swiper-button-next ${styles.swiper_button_prev_next}`} tabIndex={0} role="button"
                     aria-label="Next slide">
                    <img src="/assets/images/decorations/extra/right_arrow.png" alt="next"/>
                </div>
                <div className={'swiper-pagination'}>
                    {
                        props.ItemList.map((_, index) => {
                            return (
                                <span key={'dot-' + props.itemType + '-' + index} className="swiper-pagination-bullet"
                                      tabIndex={0}
                                      role="button"
                                      aria-label={`Go to slide ${index}`}></span>)
                        })
                    }
                </div>
            </Swiper>
        </section>
    )
}
